<span class="detail" *ngIf="!!value">
  <span class="detail__label">{{label}}: </span><span class="detail__value no-wrap">{{value}}</span>
</span>